import * as Yup from 'yup'
import { useFormik } from 'formik'
import { useLogin } from 'actions/auth'
import { useSignInMutation } from 'api'

const formSchema = Yup.object({
  email: Yup.string()
    //  this tests email shape
    .email('Please enter a valid address email.')
    // this tests email existance
    .required('Please enter a valid address email.'),
  password: Yup.string()
    .min(8, 'The password should have at least 8 characters')
    .required('Please enter a password.'),
})

const useSignInForm = () => {
  const [signInMutation] = useSignInMutation()
  const login = useLogin()

  return useFormik({
    initialValues: { email: '', password: '' },
    validationSchema: () => formSchema,
    // being explicit
    validateOnChange: false,
    validateOnBlur: true,
    validateOnMount: false,
    onSubmit: async (values, { setSubmitting, setStatus }) => {
      setSubmitting(true)
      try {
        const { data } = await signInMutation({ variables: values })

        if (!data?.signIn) throw new Error('Invalid credentials')

        login({ token: data.signIn.token, _id: data.signIn.me._id })
      } catch (error) {
        setStatus({ error })
      } finally {
        setSubmitting(false)
      }
    },
  })
}

export default useSignInForm
